/**
 * Custom Minimum Quantity Handling
 */

/**
 * Yardage Functionality
 */
const processedYardageInputs = new WeakSet();

function syncYardageInputs(displayInput, realInput) {
  let fractionalValue = parseFloat(displayInput.value) || 0;
  const minValue = parseFloat(displayInput.min) || 0.25;
  const step = 0.25;
  
  fractionalValue = Math.round(fractionalValue / step) * step;
  
  const isCartItem = realInput.name === 'updates[]';
  
  if (isCartItem && fractionalValue > 0 && fractionalValue < minValue) {
    fractionalValue = 0;
  } else if (!isCartItem) {
    fractionalValue = Math.max(minValue, fractionalValue);
  }
  
  const realValue = fractionalValue === 0 ? 0 : Math.round(fractionalValue / step);
  realInput.value = realValue;
  
  const quantitySelector = displayInput.closest('quantity-selector');
  const lineItem = displayInput.closest('line-item');
  const lineItemQuantity = displayInput.closest('line-item-quantity');
  const productInfoBlock = displayInput.closest('.product-info__block-item');
  
  let unitLabel = quantitySelector?.parentElement?.querySelector('[data-yardage-unit-label]') ||
                  quantitySelector?.nextElementSibling?.matches('[data-yardage-unit-label]') ? quantitySelector.nextElementSibling : null ||
                  lineItem?.querySelector('[data-yardage-unit-label]') ||
                  lineItemQuantity?.querySelector('[data-yardage-unit-label]') ||
                  productInfoBlock?.querySelector('[data-yardage-unit-label]');
  
  if (unitLabel) {
    const baseUnit = unitLabel.getAttribute('data-base-unit');
    if (baseUnit) {
      const roundedValue = Math.round(fractionalValue * 100) / 100;
      unitLabel.textContent = roundedValue === 1 ? baseUnit : baseUnit + 's';
    }
  }
}

function initializeYardageInput(displayInput) {
  if (processedYardageInputs.has(displayInput)) return;
  processedYardageInputs.add(displayInput);
  
  const quantityInput = displayInput.parentElement;
  const realInput = quantityInput.querySelector('[data-yardage-real-input]');
  if (realInput) {
    const realValue = parseInt(realInput.value) || parseInt(realInput.defaultValue) || 0;
    const fractionalValue = realValue * 0.25;
    displayInput.value = fractionalValue.toFixed(2);
    syncYardageInputs(displayInput, realInput);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  
  // Handle yardage inputs
  document.addEventListener('input', (event) => {
    const input = event.target;
    
    if (input.hasAttribute('data-yardage-display-input')) {
      const quantityInput = input.parentElement;
      const realInput = quantityInput.querySelector('[data-yardage-real-input]');
      if (realInput) {
        syncYardageInputs(input, realInput);
      }
      return;
    }
    
    if (!input.matches('quantity-input input') || input.hasAttribute('data-yardage-real-input')) return;
    
    const customMin = parseInt(input.dataset.customMin || input.min || 1);
    const currentValue = parseInt(input.value);
    
    if (input.value === '') return;
    
    if (!isNaN(currentValue) && currentValue < customMin && currentValue > 0) {
      if (input.name === 'updates[]') {
        input.value = 0;
      } else {
        input.value = customMin;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  
  document.addEventListener('click', (event) => {
    const decreaseButton = event.target.closest('quantity-selector .quantity-selector__button:first-of-type');
    if (!decreaseButton) return;
    
    const quantitySelector = decreaseButton.closest('quantity-selector');
    const displayInput = quantitySelector?.querySelector('[data-yardage-display-input]');
    if (!displayInput) return;
    
    const realInput = quantitySelector.querySelector('[data-yardage-real-input]');
    if (!realInput) return;
    
    const currentValue = parseFloat(displayInput.value);
    const step = parseFloat(displayInput.step || 0.25);
    const minValue = parseFloat(displayInput.min);
    const isCartItem = realInput.name === 'updates[]';
    
    const nextValue = currentValue - step;
    
    if (isCartItem && nextValue < minValue && nextValue >= 0) {
      event.preventDefault();
      displayInput.value = 0;
      syncYardageInputs(displayInput, realInput);
      realInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  
  document.addEventListener('change', (event) => {
    const input = event.target;
    
    if (input.hasAttribute('data-yardage-display-input')) {
      const quantityInput = input.parentElement;
      const realInput = quantityInput.querySelector('[data-yardage-real-input]');
      if (realInput) {
        syncYardageInputs(input, realInput);
        realInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    
    if (!input.matches('quantity-input input') || input.hasAttribute('data-yardage-real-input')) return;
    
    const customMin = parseInt(input.dataset.customMin || input.min || 1);
    const currentValue = parseInt(input.value);
    
    if (!isNaN(currentValue) && currentValue < customMin && currentValue !== 0) {
      if (input.name === 'updates[]') {
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        input.value = customMin;
      }
    }
  });
  
  // Handle decrease button clicks in cart contexts (anchor links)
  // Only intercept the DECREASE button (first button in quantity-selector)
  document.addEventListener('click', (event) => {
    const clickedLink = event.target.closest('.quantity-selector__button[href*="/cart/change"]');
    
    // Only handle if it's a link (anchor tag) and has the custom-min data attribute (decrease button)
    if (clickedLink && clickedLink.tagName === 'A' && clickedLink.dataset.customMin) {
      event.preventDefault();
      
      const customMin = parseInt(clickedLink.dataset.customMin);
      const quantitySelector = clickedLink.closest('quantity-selector');
      const input = quantitySelector?.querySelector('input');
      
      if (!input) return;
      
      const currentQuantity = parseInt(input.value);
      const step = parseInt(input.step || 1);
      const lineKey = input.dataset.lineKey;
      
      if (!lineKey) return;
      
      let targetQuantity = currentQuantity - step;
      
      // If we're at or would go below the custom minimum, remove from cart (set to 0)
      if (targetQuantity < customMin) {
        targetQuantity = 0;
      }
      
      // Trigger the cart change
      triggerCartChange(lineKey, targetQuantity);
    }
  });
  
  document.querySelectorAll('[data-yardage-display-input]').forEach(initializeYardageInput);
  
  const yardageObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.hasAttribute?.('data-yardage-display-input')) {
            initializeYardageInput(node);
          }
          node.querySelectorAll?.('[data-yardage-display-input]').forEach(initializeYardageInput);
        }
      });
    }
  });
  
  yardageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Helper function to trigger cart changes
async function triggerCartChange(lineKey, targetQuantity) {
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
  
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
    bubbles: true, 
    detail: { sections: sectionsToBundle } 
  }));
  
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity,
        sections: sectionsToBundle.join(',')
      })
    });
    
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    
    if (!response.ok) {
      const responseContent = await response.json();
      console.error('Cart change error:', responseContent);
    } else {
      const cartContent = await response.json();
      
      // Reload cart page, otherwise dispatch events
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
      } else {
        const lineItemAfterChange = cartContent['items'].filter(item => item['key'] === lineKey);
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart: cartContent
          }
        }));
      }
    }
  } catch (error) {
    console.error('Cart change failed:', error);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
  }
}

/**
 * Swatch Quantity Validation
 * Prevents increasing swatch products (identified by _product_id line item property) above quantity 1
 */
(function() {
  let localCartState = window.themeCartState || null;
  
  // Keep local cart state synchronized
  document.documentElement.addEventListener('cart:change', (event) => {
    if (event.detail.cart) {
      localCartState = event.detail.cart;
      window.themeCartState = event.detail.cart;
      // Re-process line items when cart changes
      setTimeout(processLineItems, 50);
    }
  });
  
  async function processLineItems() {
    try {
      // Use local state if available, otherwise fetch once
      let cart = localCartState;
      
      if (!cart) {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!response.ok) return;
        cart = await response.json();
        localCartState = cart;
        window.themeCartState = cart;
      }
      
      // Find all line items in the DOM
      document.querySelectorAll('line-item').forEach(lineItemElement => {
        const lineKey = lineItemElement.querySelector('[data-line-key]')?.dataset.lineKey;
        if (!lineKey) return;
        
        const cartLineItem = cart.items.find(item => item.key === lineKey);
        if (!cartLineItem) return;
        
        // Check if this is a swatch product (has _variant_id property)
        const isSwatch = cartLineItem.properties && cartLineItem.properties['_variant_id'];
        
        if (isSwatch && cartLineItem.quantity >= 1) {
          // Find the increase button (last button in quantity selector)
          const quantitySelector = lineItemElement.querySelector('quantity-selector');
          if (!quantitySelector) return;
          
          const buttons = quantitySelector.querySelectorAll('.quantity-selector__button');
          const increaseButton = buttons[buttons.length - 1]; // Last button is increase
          
          if (increaseButton && increaseButton.tagName === 'A') {
            // Replace link with disabled button
            const disabledButton = document.createElement('button');
            disabledButton.type = 'button';
            disabledButton.className = increaseButton.className;
            disabledButton.disabled = true;
            disabledButton.innerHTML = increaseButton.innerHTML;
            disabledButton.setAttribute('data-tooltip', 'Fabric swatches are limited to 1 per product.');
            increaseButton.replaceWith(disabledButton);
          }
          
          // Also disable direct input changes above 1
          const input = quantitySelector.querySelector('input[data-line-key]');
          if (input) {
            input.setAttribute('max', '1');
            input.addEventListener('input', (e) => {
              if (parseInt(e.target.value) > 1) {
                e.target.value = 1;
              }
            });
          }
        }
      });
    } catch (error) {
      console.error('Error processing swatch line items:', error);
    }
  }
  
  // Process on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processLineItems);
  } else {
    processLineItems();
  }
  
  // Watch for new line items added to DOM
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        processLineItems();
        break;
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
